import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  getLeftCheckedPostalOperators,
  getRightCheckedPostalOperators,
} from '../../../../common/user/redux/selectors/UserDataSelectors';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../../common/tables/actions/ListTableActions';
import TableDefinitions from '../../../../common/TableDefinitions';
import ListTable from '../../../../common/tables/ListTable';
import {
  getColumns,
  getData,
  getTotalColumns,
  getTotalData,
  getIsLoading,
  getFilteredData,
  getTotalFilteredData,
} from '../redux/selectors/FluxVolumeOperatorReportSelectors';
import FluxVolumeOperatorReportSelectionCriteriaContainer from './FluxVolumeOperatorReportSelectionCriteriaContainer';
import downloadTypes from '../../../../common/tables/excel/DownloadTypes';
import { getGlobalEndDate, getGlobalStartDate } from '../../../../common/selection-criteria/period/redux/selectors/GlobalPeriodSelectionSelectors';
import { setGlobalEndDateSelectionActionCreator, setGlobalStartDateSelectionActionCreator } from '../../../../common/selection-criteria/period/redux/actions/GlobalPeriodSelectionActions';

const leftTree = {
  title: 'Focal Operators',
  roleFilter: true,
};
const rightTree = {
  title: 'Operators',
  roleFilter: false,
  useGlobalPresets: true,
};

class FluxVolumeOperatorReportContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
      selectedStartDate: this.props.globalStartDate,
      selectedEndDate: this.props.globalEndDate,
    };
  }

  onStartDateChange = (newDate) => {
    this.setState({
      selectedStartDate: newDate,
    });
    this.props.setGlobalStartDateSelectionActionCreator(newDate);
  }

  onEndDateChange = (newDate) => {
    this.setState({
      selectedEndDate: newDate,
    });
    this.props.setGlobalEndDateSelectionActionCreator(newDate);
  }

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
    });

    this.props.tableLoadData(
      { tableId: 'REPORTING_FLUX_VOLUME_OPERATOR' },
      this.props.appContext.appContext,
      {
        endDate: this.state.selectedEndDate,
        focals: this.props.leftCheckedPostalOperators,
        startDate: this.state.selectedStartDate,
        targets: this.props.rightCheckedPostalOperators,
      },
    );
  };

  render() {
    const { showResult, selectedStartDate, selectedEndDate } = this.state;
    const {
      isLoading,
      data,
      columns,
      columnsTotal,
      dataTotal,
      totalFilteredData,
      filteredData,
    } = this.props;

    return (
      <div>
        <FluxVolumeOperatorReportSelectionCriteriaContainer
          open={data.length === 0}
          title="Flux & Volume Operator Report"
          onApply={this.onCriteriaApply}
          selectedStartDate={selectedStartDate}
          onStartDateChange={this.onStartDateChange}
          selectedEndDate={selectedEndDate}
          onEndDateChange={this.onEndDateChange}
          leftTree={leftTree}
          rightTree={rightTree}
        />
        <div className="general-content-container" style={{ flexDirection: 'column' }}>
          {(showResult || data.length > 0) && (
            <div style={{ minHeight: '740px' }}>
              <div className="full-width">
                <div className="list-table-container" style={{ paddingBottom: '20px' }}>
                  <ListTable
                    listId={TableDefinitions.REPORTING_FLUX_VOLUME_OPERATOR.id}
                    loading={isLoading}
                    columns={columns}
                    data={data}
                    keyField="id"
                    selectCheckbox
                    pagination
                    downloadType={downloadTypes.EXCEL}
                  />
                </div>
              </div>
              <div className="full-width">
                <div className="list-table-container" style={{ paddingBottom: '20px' }}>
                  <ListTable
                    listId={TableDefinitions.REPORTING_FLUX_VOLUME_OPERATOR.id}
                    loading={isLoading}
                    columns={columnsTotal}
                    data={filteredData.length > 0 ? totalFilteredData : dataTotal}
                    keyField="code"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

FluxVolumeOperatorReportContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  dataTotal: PropTypes.arrayOf(PropTypes.object),
  totalFilteredData: PropTypes.arrayOf(PropTypes.object),
  filteredData: PropTypes.arrayOf(PropTypes.object),
  columnsTotal: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  leftCheckedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  rightCheckedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  isLoading: PropTypes.bool,
  globalStartDate: PropTypes.instanceOf(Date),
  globalEndDate: PropTypes.instanceOf(Date),
  setGlobalStartDateSelectionActionCreator: PropTypes.func,
  setGlobalEndDateSelectionActionCreator: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    dataTotal: getTotalData(state),
    columnsTotal: getTotalColumns(state),
    leftCheckedPostalOperators: getLeftCheckedPostalOperators(state),
    rightCheckedPostalOperators: getRightCheckedPostalOperators(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
    globalStartDate: getGlobalStartDate(state),
    globalEndDate: getGlobalEndDate(state),
    totalFilteredData: getTotalFilteredData(state),
    filteredData: getFilteredData(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  setGlobalStartDateSelectionActionCreator,
  setGlobalEndDateSelectionActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FluxVolumeOperatorReportContainer);
